export * from './diarios.interface';
export * from './documentos.interface';
export * from './entidades.interface';
export * from './envio-de-materia.interface';
export * from './informacoes.interface';
export * from './resposta-api.interface';
export * from './liberar-pdf.interface';
export * from './menu.interface';
export * from './perfil.interface';
export * from './permissao.interface';
export * from './empresa.interface';
export * from './token.interface';
export * from './parametros-da-materia.interface';
export * from './credenciamento.interface';
export * from './cliente.interface';
export * from './materias-recebidas';
